
import { throwError as observableThrowError } from 'rxjs'

import { map, tap } from 'rxjs/operators'
import { formatProducts, setAddOns, setProducts } from 'services/product'
import { getUserSuccess } from 'services/users/actions'
import { PPAddOn, PPProduct } from 'shared'
import { getState, StoreThunkDispatch } from 'store/state'
import { MS_IN_SEC } from 'utils/constants'
import { V1 } from './net'

export const ACTION_LOGIN_ERROR = 'ACTION_LOGIN_ERROR'
export const ACTION_CLEAR_ERRORS = 'ACTION_CLEAR_ERRORS'

export function login(email: string, password: string, params?: Partial<Record<string, string>>) {
  return (dispatch: StoreThunkDispatch, getState: getState) => {
    const authError = getState().auth.error
    // Do not make request if user login is blocked
    if (authError?.retryAt && new Date(authError.retryAt).getTime() > Date.now()) {
      return observableThrowError(() => '')
    }
    const handleError = (error: { message: string, code: string, data: any }) => {
      if (error.code === 'max-attempts-reached') {
        dispatch({
          type: ACTION_LOGIN_ERROR,
          payload: { retryAt: error.data.retryAt * MS_IN_SEC }
        })

        throw new Error()
      }

      if (error.code === 'restricted-access') {
        dispatch({
          type: ACTION_LOGIN_ERROR,
          payload: { restrictedAccess: true }
        })
        throw new Error()
      }
      const err = new Error(error.message) as Error & { code?: string, data?: any }
      err.code = error.code
      err.data = error.data
      throw err
    }

    // Clear errors before login request
    dispatch({
      type: ACTION_CLEAR_ERRORS
    })
    return dispatch(V1.login(email, password, params)).pipe(
      map(res => ({
        ...res,
        products: res.subscriptions?.products ? formatProducts(res.subscriptions.products) : [],
        addons: res.subscriptions?.addons || []
      })))
      .pipe(tap(
        (response) => {
          if (response.error) {
            handleError(response.error)
          }

          const products = response.products as PPProduct[]
          const product = products.find((p) => p.id === response.user.account.product) as PPProduct
          dispatch(getUserSuccess(response.user, product))
          dispatch(setProducts(products))
          dispatch(setAddOns({ 
            list: response.addons as PPAddOn[] || [], 
            purchased: response.user.account.addons || {} 
          }))
        },
        error => {
          handleError(error.response.error)
        }
      ))
  }
}

export function updatePassword(newPassword: string, oldPassword: string) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.updatePassword(newPassword, oldPassword)).pipe(tap(
      (response) => {
        if (response.error) {
          throw new Error(response.error.message)
        }
      }
    ))
  }
}

export function requestPassword(email: string) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.requestPassword(email))
  }
}
